import { render, staticRenderFns } from "./date-template.vue?vue&type=template&id=88ffbb24&scoped=true&"
import script from "./date-template.vue?vue&type=script&lang=js&"
export * from "./date-template.vue?vue&type=script&lang=js&"
import style0 from "./date-template.vue?vue&type=style&index=0&id=88ffbb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ffbb24",
  null
  
)

export default component.exports